// @ts-nocheck
import React, { useState } from 'react';
import {
  loadTerritories,
  exportTerritoryData,
} from '../../../../actions/territoryActions';
import { Link, useLocation } from 'react-router-dom';
import { Table, SimpleTextFilter, getVisibleColumns } from '../../../common/Table';
import { CommaNumber_NoDecimal, hexToRgbA } from '../../../../util/formatter';
import Loading from '../../../common/Loading';
import KwPanel from '../../../common/KwPanel';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../../hooks/useTableSettings';
import { useTranslation } from 'react-i18next';
import { scopes } from '../../../../constants/scopes';

export interface TerritoryListProps {
  reload?: unknown;
}

function TerritoryList({ reload }: TerritoryListProps) {
  const { t } = useTranslation();
  const allColumns = [
    'name',
    'description',
    'numberAllowedSKUs',
    'numberDisallowedSKUs',
  ];
  const defaultVisibleColumns = allColumns;
  const [territories, setTerritories] = useState();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { tableSettings, handleSetTableSettings: setTableSettings, filters, filterChange, isLoading } =
    useTableSettings(
      'territorylist-settings-2.23',
      getTableSettingsDefaults({ defaultSort: 'name', defaultVisibleColumns }),
      null,
      loadTerritories,
      setTerritories,
      reload,
      t('Failed to load territories')
    );

  // The base config of the columns, this will be filtered based on the visible (above)
  let columnsConfig = [
    {
      Key: 'name',
      Label: t('Name'),
      width: '20%',
      Render: (territory) => (
        <div
          className="p-2 d-flex align-items-center territory-td"
          style={
            territory.colourHex
              ? {
                  borderLeft: `3px solid ${territory.colourHex}`,
                }
              : null
          }
        >
          <Link to={'/settings/territory/' + territory.id}>
            {territory.name}
          </Link>
        </div>
      ),
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
            testId="territory-name-filter"
          />
        ),
      },
    },
    {
      Key: 'description',
      Label: t('Description'),
      width: '40%',
      Render: (territory) => territory.description,
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
          />
        ),
      },
    },
    {
      Key: 'numberAllowedSKUs',
      Label: t('Number of Allowed SKUs'),
      width: '20%',
      className: 'text-right num no-wrap',
      Render: (item) => (
        <Link to={`/games?${scopes.ALLOWEDTERRITORY}=${item.id}`}>
          {CommaNumber_NoDecimal(item.numberAllowedSKUs)}
        </Link>
      ),
    },
    {
      Key: 'numberDisallowedSKUs',
      Label: t('Number of Disallowed SKUs'),
      width: '20%',
      className: 'text-right num no-wrap',
      Render: (item) => (
        <Link to={`/games?${scopes.DISALLOWEDTERRITORY}=${item.id}`}>
          {CommaNumber_NoDecimal(item.numberDisallowedSKUs)}
        </Link>
      ),
    },
  ];

  // filter
  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const columns = getVisibleColumns(visibleColumns, columnsConfig);

  // return an alaska table
  return territories?.data ? (
    <KwPanel className="mb-4">
      <Table
        columns={columns}
        allColumns={allColumns}
        rows={territories.data.map((x) => {
          return { Key: x.id, ...x };
        })}
        totalRowCount={territories.totalRowCount}
        filteredRowCount={territories.filteredRowCount}
        tableSettings={tableSettings}
        setTableSettings={setTableSettings}
        isLoading={isLoading}
        filters={filters}
        filterChange={filterChange}
        exportData={exportTerritoryData}
        trStyle={(row) => {
          return {
            backgroundColor: `${hexToRgbA(row.colourHex, 0.0375)}`,
          };
        }}
      />
    </KwPanel>
  ) : (
    <Loading></Loading>
  );
}

export default TerritoryList;
